import BulkUploadModule from './components/BulkUpload';
import { BulkUploadStyle } from './components/BulkUpload/overwriteStyle';
import BulkUploadHistory from './components/BulkUpload/History';
import BulkUploadOngoingUploads from './components/BulkUpload/OngoingUploads';
import BulkUploadRecentUploads from './components/BulkUpload/RecentUploads';
import BulkUploadErrorListComponent from './components/BulkUpload/ErrorListComponent';
import LoaderModule from './components/Loader';
import ZeroSearchHandlerModule from './components/ZeroSearchHandler';
import * as SelectFieldModule from './components/SelectField';
import TableIconsModule from './components/TableIcons';
import * as InputFieldModule from './components/InputField';
import ModalDialogModule from './components/ModalDialog';
import { ModalDialogStyle } from './components/ModalDialog/overwriteStyle';
import { ModalDialog as ModalDialogWoStylesModule } from './components/ModalDialog/ModalDialog';
import ContextMenuComponentModule from './components/ContextMenuComponent';
import { ContextMenuComponent as ContextMenuComponentWoStylesModule } from './components/ContextMenuComponent/ContextMenuComponent';
import { default as NotificationConfig } from './components/Notification/config';
import * as LocalizeLangModule from './components/LocalizeLang';
import * as ToolTipsModule from './components/ToolTips';
import AlertBannerModule from './components/AlertBanner';
import AutoCompleteModule from './components/AutoCompleteField';
import AutoRefreshModule from './components/AutoRefresh';
import BreadCrumbsModule from './components/BreadCrumbs';
import DateRangeModule from './components/DateRange';
import DateRangePickerModule from './components/DateRangePicker';
import DrawerComponentModule from './components/DrawerComponent';
import ErrorHandlerModule from './components/ErrorHandler';
import ErrorMessageModule from './components/ErrorMessage';
import FooterModule from './components/Footer';
import HeaderModule from './components/Header';
import HelpDocDetailModule from './components/HelpDocDetail';
import LanguageSelectorModule from './components/LanguageSelector';
import MarketSelectorModule from './components/MarketSelector';
import LayoutModule from './components/Layout';
import LeftNavigationModule from './components/LeftNavigation';
import MessageModule from './components/Message';
import PopoverModule from './components/Popover';
import ProgressBarModule from './components/ProgressBar';
import QuickTourModule from './components/QuickTour';
import RichTextEditorModule from './components/RichTextEditor';
import SearchCriteriaModule from './components/SearchCriteria';
import SwitchModule from './components/Switch';
import TypeAheadModule from './components/TypeAhead';
import WizardModule from './components/Wizard';
import ToggleItemModule from './components/ToggleItem';
import StrideLeftNavigation from './components/StrideNavigation/component/StrideNavigation';
import StrideLeftNavIcons from './components/StrideNavigation/assets/index';
import { StrideIconList } from './components/StrideNavigation/assets/Stride_Icons/index';
import { GscopeIcons, GscopeIconsList } from './components/GscopeIcons/index';
import { gscopeTheme } from './theme';
export { withAppUtils } from './hoc/app-utils';
export { default as Hooks } from './hooks';
import BulkUpdateModule from './components/BulkUpload/BulkUpdate';

const BulkUpload = {
    default: BulkUploadModule,
    overwriteStyle: BulkUploadStyle,
    History: BulkUploadHistory,
    OngoingUploads: BulkUploadOngoingUploads,
    RecentUploads: BulkUploadRecentUploads,
    ErrorListComponent: BulkUploadErrorListComponent,
};
const Loader = {
    default: LoaderModule,
};
const ZeroSearchHandler = {
    default: ZeroSearchHandlerModule,
};
const SelectField = {
    default: SelectFieldModule,
};
const TableIcons = {
    default: TableIconsModule,
};
const InputField = {
    default: InputFieldModule,
};
const ModalDialog = {
    default: ModalDialogModule,
    withoutStyles: ModalDialogWoStylesModule,
    overwriteStyle: { ModalDialogStyle },
};
const ContextMenuComponent = {
    default: ContextMenuComponentModule,
    withoutStyles: ContextMenuComponentWoStylesModule,
};
const Notification = {
    config: NotificationConfig,
};

const AlertBanner = {
    default: AlertBannerModule,
};
const AutoCompleteField = {
    default: AutoCompleteModule,
};
const AutoRefresh = {
    default: AutoRefreshModule,
};
const BreadCrumbs = {
    default: BreadCrumbsModule,
};
const DateRange = {
    default: DateRangeModule,
};
const DateRangePicker = {
    default: DateRangePickerModule,
};
const DrawerComponent = {
    default: DrawerComponentModule,
};
const ErrorHandler = {
    default: ErrorHandlerModule,
};
const ErrorMessage = {
    default: ErrorMessageModule,
};
const Footer = {
    default: FooterModule,
};
const Header = {
    default: HeaderModule,
};
const HelpDocDetail = {
    default: HelpDocDetailModule,
};
const LanguageSelector = {
    default: LanguageSelectorModule,
};
const MarketSelector = {
    default: MarketSelectorModule,
};
const Layout = {
    default: LayoutModule,
};
const LeftNavigation = {
    default: LeftNavigationModule,
};
const Message = {
    default: MessageModule,
};
const Popover = {
    default: PopoverModule,
};
const ProgressBar = {
    default: ProgressBarModule,
};
const QuickTour = {
    default: QuickTourModule,
};
const RichTextEditor = {
    default: RichTextEditorModule,
};
const SearchCriteria = {
    default: SearchCriteriaModule,
};
const Switch = {
    default: SwitchModule,
};
const TypeAhead = {
    default: TypeAheadModule,
};
const Wizard = {
    default: WizardModule,
};
const LocalizeLang = {
    default: LocalizeLangModule,
};
const ToolTips = {
    default: ToolTipsModule,
};
const ToggleItem = {
    default: ToggleItemModule,
};
const StrideNavigation = {
    default: StrideLeftNavigation,
};
const LeftNavIconList = {
    gscope: GscopeIconsList,
    stride: StrideIconList,
};

const LeftNavIcons = {
    stride: StrideLeftNavIcons,
    gscope: GscopeIcons,
};

const BulkUpdate = {
    default: BulkUpdateModule,
};

// for onboard module listing down both the gscope & stride icons in stride env
const CommonComponent = (props) => {
    return (
        <>
            <StrideLeftNavIcons hidefallbackIcon={true} {...props} />
            <GscopeIcons {...props} />
        </>
    );
};

const onboardModuleIconList = {
    stride: [...StrideIconList, ...GscopeIconsList],
};

const onboardModuleIconComponent = {
    stride: CommonComponent,
};

export {
    BulkUpload,
    Loader,
    ZeroSearchHandler,
    SelectField,
    TableIcons,
    InputField,
    ModalDialog,
    ContextMenuComponent,
    Notification,
    AlertBanner,
    AutoRefresh,
    AutoCompleteField,
    BreadCrumbs,
    DateRange,
    DateRangePicker,
    DrawerComponent,
    ErrorHandler,
    ErrorMessage,
    Footer,
    Header,
    HelpDocDetail,
    LanguageSelector,
    MarketSelector,
    Layout,
    LeftNavigation,
    Message,
    Popover,
    ProgressBar,
    QuickTour,
    RichTextEditor,
    SearchCriteria,
    Switch,
    TypeAhead,
    Wizard,
    LocalizeLang,
    ToolTips,
    gscopeTheme,
    ToggleItem,
    LeftNavIconList,
    StrideNavigation,
    LeftNavIcons,
    onboardModuleIconList,
    onboardModuleIconComponent,
    BulkUpdate,
};
